import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        fontFamily: "Source Sans Pro",
    },

    title: {
        fontFamily: "Source Sans Pro", fontWeight: 600, width: "415px", fontSize: "20px", lineHeight: "28px", color: "#414141"
    },

    content: {
        fontFamily: "Source Sans Pro", fontWeight: 400, fontSize: "16px", lineHeight: "24px", color: "#595959", width: "415px"
    },

    cancelButton: {
        borderRadius: "2px", backgroundColor: "#008381", textTransform: 'none',
        fontWeight: 600, fontFamily: "Source Sans Pro", fontSize: "16px", lineHeight: "24px", textAlign: "center", color: "#FFFFFF",
        boxShadow: "none", height: "40px", border: "2px", padding: "8px 16px", width: "149px",
        '&:hover': {
            backgroundColor: "#008381",
            textTransform: 'none',
            boxShadow: "none",
        },
    },

    okButton: {
        borderRadius: "2px", backgroundColor: "#FFFFFF", textTransform: 'none',
        fontWeight: 600, fontFamily: "Source Sans Pro", fontSize: "16px", lineHeight: "24px", textAlign: "center", color: "#414141",
        boxShadow: "none", width: "72px", height: "40px", border: "2px solid #AAAAAA", padding: "8px 16px"
    },

    hr: { width: "100%", color: "#D2D2D2", height: "1px" },

    blueHighlight: { color: "#006AD2", fontWeight: 600, }
});

export function DraftMedicationDialogBox(props: any) {
    const classes = useStyles();
    const { when, onOK, onCancel, key } = props;
    const history = useHistory();
    const [showPrompt, setShowPrompt] = useState(false);
    const [currentPath, setCurrentPath] = useState("");

    useEffect(() => {
        setShowPrompt(when);
    }, [key]);

    const handleOK = useCallback(async () => {
        if (onOK) {
            const canRoute = await Promise.resolve(onOK());
            if (canRoute) {
                setShowPrompt(false);
                history.push(currentPath);
            }
        }
    }, [onOK]);

    const handleCancel = useCallback(async () => {
        if (onCancel) {
            setShowPrompt(false);
            let path = window.location.pathname;
            if (path.split('/')[5]) {
                path = path ? path.substring(0, path.lastIndexOf("/")) : '';
                window.location.href = path;
            }

        }
    }, [onCancel]);

    return (
        <Dialog
            open={showPrompt}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className={classes.title} id="alert-dialog-title">
                <div className={classes.title}>Don’t forget to finalise your draft medications</div>
            </DialogTitle>

            <DialogContent>
                <DialogContentText className={classes.content} id="alert-dialog-description">
                    <div>
                        You can finalise all draft medications by clicking on the <span className={classes.blueHighlight}>Finalise chart</span> button (located on the top right of the resident’s medication chart).
                        <br />
                        <br />
                        <b>Please note:</b> Draft medications will be removed if they are not finalised in the same day.
                    </div>
                </DialogContentText>
            </DialogContent>

            <hr className={classes.hr} />
            <DialogActions>
                <Button onClick={handleOK} className={classes.okButton}>
                    Leave</Button>
                <Button autoFocus onClick={handleCancel} className={classes.cancelButton}>
                    Stay on this page
                </Button>
            </DialogActions>
        </Dialog>)
}